import { ZLBoltOptions } from "@zerolight-core/libzl";
import { VisualizerConfiguration } from "../types/VisualizerTypes";

export function getDirect2DOptions(visualizerConfiguration: VisualizerConfiguration, service?: string, region? :string):ZLBoltOptions
{
    if ("zlboltOptions" in visualizerConfiguration)
        return {
            ...visualizerConfiguration.zlboltOptions,
            connectionParameters: {
                ...visualizerConfiguration.zlboltOptions.connectionParameters,
                ...service ? { environment: service } : {},
                ...region ? { region: region } : {},
            }
        } as ZLBoltOptions
    
    const cso = visualizerConfiguration.cloudStreamOptions;
    return {
        ...visualizerConfiguration.cloudStreamOptions,
        car: {
            manufacturer: cso.appSelect?.project ?? "",
            model: cso.appSelect?.app ?? "",
            year: cso.appSelect?.id ?? "",
        },
        connectionParameters: {
            customer: cso.cloudConnectionParameters.customer!,
            region: cso.cloudConnectionParameters.region,
            environment: cso.cloudConnectionParameters.renderService,
            protocol: "https",

            ...service ? { environment: service } : {},
            ...region ? { region: region } : {},
        }
    } as ZLBoltOptions
}